// prevent user from navigating back by hiding subscription funnel by default
$(document).ready(() => {
  hideSubscriptionFunnel();
  // $("body").on('click', '#subscription-funnel-headers-sub', () => {
  //     console.log("header clicked");
  // });

  // $("#subscription-funnel-headers-sub").click(() => console.log("header clicked"));
  
})

$(document).on('change', () => {
  console.log("changed");
})

function viewSizeGuide() {
  console.log("size guide");
}

function showMaterialsModal() {
  $("#materials-modal-wrapper").css("display", "flex");
  // disable scrolling
  $('body').css('overflow', 'hidden');
}

function hideMaterialsModal() {
  $("#materials-modal-wrapper").hide();
  // disable scrolling
  $('body').css('overflow', 'hidden');
}

// reset all data
function resetAllData() {
  // reset data attributes
  $("#subscription-funnel-selected-product").attr("data-handle", "");
  $("#subscription-funnel-selected-product").attr("data-size", "");
  $("#subscription-funnel-selected-product").attr("data-qty", "");
  $("#subscription-funnel-selected-product").removeData('variantMap');
}

function loadSubscriptionFunnel() {
  $("#subscription-funnel").show();

  // set page to 1
  $("#subscription-funnel-selected-product").attr("data-page", "1");

  // render the current screen
  renderScreen();

  // disable scrolling
  $('body').css('overflow', 'hidden');
}

function hideSubscriptionFunnel() {
  $("#subscription-funnel").hide();
  // re-enable scrolling
  $('body').css('overflow', 'auto');

  // deselect everything
  $(`#qty-selector-options .qty`).removeClass('selected');
  $(`.qty-selector-product-circle`).removeClass('selected')
  $(`.qty-selector-product-circle svg.checkmark`).hide();

  $(`.style-selector-product-image`).removeClass('selected');
  $(`.style-selector-product-circle`).removeClass('selected');
  $(`.style-selector-product-circle svg.checkmark`).hide();
  $(`.style-selector-product-circle-mobile`).removeClass('selected');
  $(`.style-selector-product-circle-mobile svg.checkmark`).hide();
  
  $(`.style-selector-product-headers .select`).removeClass('selected');
  $(`.style-selector-product-headers .select`).text('Select');
  
  $(`.size-selector-product-circle`).removeClass('selected')
  $("#size-selector-options .size").removeClass("selected");
  $(`.size-selector-product-circle svg.checkmark`).hide();

  $('.select-button-mobile').removeClass('selected');
  $('.select-button-mobile').text('Select');

  $('.upsell-add-to-cart').removeClass('clicked');
  $('.upsell-add-to-cart').text("Add");

  // hide every other screen
  $("#style-selector").hide();
  $("#size-selector").hide();
  $("#qty-selector").hide();
  $("#upsell-selector").hide();

  // reset any data a user has added
  resetAllData();
}

// select a size 
function getSubscriptionItem(id, handle) {

  if (window.innerWidth > 991) {
    // unselect everything first
    $(`.style-selector-product-image`).removeClass('selected');
    $(`.style-selector-product-circle`).removeClass('selected');
    $(`.style-selector-product-circle-mobile`).removeClass('selected');
    $(`.style-selector-product-circle svg.checkmark`).hide();
    $(`.style-selector-product-circle-mobile svg.checkmark`).hide();
    $(`.style-selector-product-image-mobile`).removeClass('selected')

    // show that the item is checked
    $(`#style-selector-product-image-${id}`).addClass('selected');
    $(`#style-selector-product-circle-${id}`).addClass('selected');
    $(`#style-selector-product-circle-mobile-${id}`).addClass('selected');
    $(`#style-selector-product-circle-mobile-${id} svg.checkmark`).show();
    $(`#style-selector-product-circle-${id} svg.checkmark`).show();
    $(`#style-selector-product-image-mobile-${id}`).addClass('selected')
    
  } else {
    $('.select-button-mobile').removeClass('selected');
    $('.select-button-mobile').text('Select');
    $(`#select-button-${id}`).addClass('selected');
    $(`#select-button-${id}`).text('Selected');
  }
  


  // set product handle data of our selected product
  $("#subscription-funnel-selected-product").attr("data-handle", handle);
}

// select a size obvuiosly
function selectSize(size) {

  // unselect everything first
  $("#size-selector-options .size").removeClass("selected");
  $(`.size-selector-product-circle`).removeClass('selected')
  $(`.size-selector-product-circle svg.checkmark`).hide();
  
  // show that the size is checked
  $(`#size-selector-option-${size}`).addClass('selected');
  $(`#size-selector-product-circle-${size}`).addClass('selected')
  $(`#size-selector-product-circle-${size} svg.checkmark`).show();

  // set size data of our selected product
  $("#subscription-funnel-selected-product").attr("data-size", size);
}

// select a quantity
function selectQty(qty) {
  // unselect everything first
  $(`#qty-selector-options .qty`).removeClass('selected');
  $(`.qty-selector-product-circle`).removeClass('selected')
  $(`.qty-selector-product-circle svg.checkmark`).hide();
  
  // show that the size is checked
  $(`#qty-selector-options-${qty}`).addClass('selected');
  $(`#qty-selector-product-circle-${qty}`).addClass('selected')
  $(`#qty-selector-product-circle-${qty} svg.checkmark`).show();

  // set data of our selected product
  $("#subscription-funnel-selected-product").attr("data-qty", qty);
}

// add item to cart
async function upsellAddToCart(id, handle) {

  // if the text says remove, then we remove
  if ($(`#upsell-add-to-cart-${id}`).hasClass('clicked')) {

    $(`#upsell-add-to-cart-${id}`).removeClass('clicked');
    $(`#upsell-add-to-cart-${id}`).text("Add");

    // delete key
    const variantMap = $("#subscription-funnel-selected-product").data('variantMap');
    variantMap.delete(handle);
    $("#subscription-funnel-selected-product").data('variantMap', variantMap);

    return;
  }
  
  // utility function to format our variant title
  function formatVariantTitle(arr) {
    let str = "";
    arr.forEach((value, index) => {
        if (index === arr.length - 1) {
            str += value;
            return;
        }
        str += `${value} / `
    })
    return str;
  }
  
  const selects = [...$(`.upsell-product-select-${id}`)].map(select => select.value);

  // ensure user selects all options before adding to cart
  if (selects.some(v => v === "")) {
    alert("Please select all options.");
    return;
  }

  $(`#upsell-add-to-cart-${id}`).addClass('clicked');
  $(`#upsell-add-to-cart-${id}`).text("Remove");

  // append variant's handle and id to variant map
  if (typeof $("#subscription-funnel-selected-product").data('variantMap') === 'undefined') {
      const variantMap = new Map();
      variantMap.set(handle, formatVariantTitle(selects));
      $("#subscription-funnel-selected-product").data('variantMap', variantMap);
    
  } else {
      const variantMap = $("#subscription-funnel-selected-product").data('variantMap');
      variantMap.set(handle, formatVariantTitle(selects));
      $("#subscription-funnel-selected-product").data('variantMap', variantMap);
  }
}

function verifyInputs(page_num) {
  switch(page_num) {
    case "1":
      return $("#subscription-funnel-selected-product").attr("data-handle") !== "";
      break;
    case "2":
      return $("#subscription-funnel-selected-product").attr("data-size") !== "";
      break;
    case "3":
      return $("#subscription-funnel-selected-product").attr("data-qty") !== "";
      break;
    case "4":
      return true;
      break;
  }
}

// navigate back pages
function navigateBack() {
  const currentPage = $("#subscription-funnel-selected-product").attr("data-page");
  if (currentPage === "1") {

    // check if we're on shop-subscription
    if (window.location.pathname.includes("shop-subscription")) {
      window.location.href = window.location.origin + '/'
      return;
    } 

    hideSubscriptionFunnel();
    
    return;
  }
  $("#subscription-funnel-selected-product").attr("data-page", `${parseInt(currentPage) - 1}`);
  renderScreen()
}

function navigateNext() {
  
  const currentPage = $("#subscription-funnel-selected-product").attr("data-page");

  // verify all inputs were inputted
  if (!verifyInputs(currentPage)) {
    alert("Please select one of the options.");
    return;
  }
  
  $("#subscription-funnel-selected-product").attr("data-page", `${parseInt(currentPage) + 1}`);
  // if (parseInt(currentPage) >= 4) {
  //   $("#subscription-funnel-next").text("Continue to checkout");
  // } else {
  //   $("#subscription-funnel-next").text("Next");
  // }
  renderScreen();
}

function between(innerX, outerX, lowerY) {
  return (window.innerWidth >= innerX && window.innerWidth <= outerX) && window.innerHeight >= lowerY;
}

// navigate through the different pages
async function renderScreen() {
    switch($("#subscription-funnel-selected-product").attr("data-page")) {

      // page 1
      case "1":
        // show style selector
        $("#style-selector").show();
        $("#size-selector").hide();
        $("#qty-selector").hide();
        $("#upsell-selector").hide();

        // change headers
        $("#subscription-funnel-headers-main").text("Select your style");
        $("#subscription-funnel-headers-sub").text("Which coverage fits your style?");

        // progress bar stuff
        $(".circle").removeClass("selected");
        $(".style-circle").addClass("selected");

        // change next button text
        $("#subscription-funnel-next").text("Next");

        if ($("#specific-preferences").css("display") === "none" && window.innerWidth >= 414) {
          $("#specific-preferences").show();
        }
        $("#cancel-anytime").show();
        $("#middle-content").css("height", "fit-content");

        if (window.innerWidth > 991) {
          $("#bottom-content").css("padding-bottom", "40px");
        }
        
        break;

      // page 2
      case "2":
        // show size selector
        $("#size-selector").show();
        $("#style-selector").hide();
        $("#qty-selector").hide();
        $("#upsell-selector").hide();

        // change headers
        $("#subscription-funnel-headers-main").text("Select your size");
        if (window.innerWidth < 991) {
          $("#subscription-funnel-headers-sub").text("");
        } else {
          $("#subscription-funnel-headers-sub").text("Let's get to know each other");
        }

        // progress bar stuff
        $(".circle").removeClass("selected");
        $(".size-circle").addClass("selected");

        // change next button text
        $("#subscription-funnel-next").text("Next");

        $("#cancel-anytime").hide();
        $("#specific-preferences").hide();

        if (window.innerWidth > 991) {
          $("#bottom-content").css("padding-bottom", "0px");
        }
        
        $("#middle-content").css("height", "65%");

        // show subtitle if mobile screen size warrants it
        // if (between(375, 380, 710) || between(380, 390, 720) || between(390, 400, 720)) {
          
        // }
        
        break;

      // page 3
      case "3":
        $("#size-selector").hide();
        $("#style-selector").hide();
        $("#qty-selector").show();
        $("#upsell-selector").hide();

        // change headers
        $("#subscription-funnel-headers-main").text("Select your quantity");
        $("#subscription-funnel-headers-sub").text("Undies per pack");

        // auto-select option 3
        $("#qty-selector-options-3").trigger("click");

        // progress bar stuff
        $(".circle").removeClass("selected");
        $(".qty-circle").addClass("selected");

        // change next button text
        $("#subscription-funnel-next").text("Next");

        break;

      // page 4
      case "4":
        $("#qty-selector").hide();
        $("#upsell-selector").show();
        $("#subscription-funnel-selected-product").attr("data-page", 4);

        // change headers
        $("#subscription-funnel-headers-main").text("Add one-off purchases");
        $("#subscription-funnel-headers-sub").text("Sweet add-ons for this month only");

        // progress bar stuff
        $(".circle").removeClass("selected");
        $(".upsell-circle").addClass("selected");
        
        // change next button text
        $("#subscription-funnel-next").text("Checkout");
        
        break;

      // add items to cart and go to checkout
      case "5":
        // change next button text
        $("#subscription-funnel-next").text("Loading...");
        
        // retrieve our product data for the subscription item
        const productHandle = $("#subscription-funnel-selected-product").attr("data-handle");
        const productSize = $("#subscription-funnel-selected-product").attr("data-size");
        const productQty = $("#subscription-funnel-selected-product").attr("data-qty");

        const response = await $.get(`/products/${productHandle}.json`).then(data => data.product.variants).catch(err => alert(err.message));
        const selectedVariant = response.filter(v => v.title === `${productSize} / ${productQty}`)[0].id;


        // push subscription item to cart first
        const subscriptionProductData = {
            "id": selectedVariant,
            "quantity": 1,
            "properties": {
                "subscribe": 1,
                "shipping_interval_unit_type": 'Months',
                "shipping_interval_frequency": '1'
            }
        }
        await jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: subscriptionProductData,
            dataType: 'json'
        });

        
        let items = [];

        // retrieve our upsell data
        const variantMap = $("#subscription-funnel-selected-product").data('variantMap');

        // if it's undefined, go to checkout 
        if (variantMap === undefined) {
          reChargeProcessCart()
          return;
        }

        for ([handle, variantTitle] of variantMap) {
            // get the variant id of the upsells to add to our items array
            const response = await $.get(`/products/${handle}.json`).then(data => data.product.variants);
            const variantID = response.filter(v => v.title === variantTitle)[0].id;
            items.push({id: variantID, quantity: 1});
        };  

        // add items to cart then go to checkout
        let formData = {
         'items': items
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          hideSubscriptionFunnel();
          reChargeProcessCart()
          // document.location.href = '/checkout'
        })
        .catch((error) => {
          console.error('Error:', error);
          alert(error);
        });
        
        break;
    }
}